document.addEventListener('DOMContentLoaded', async () => {
    const form = document.getElementById('customer-settings-form');
    const shopId = form.getAttribute('data-shop-id');
    const customerId = form.getAttribute('customer-id');
    const locationId = form.getAttribute('data-location-id');

    if (!shopId || !locationId || !customerId) {
        showFormError('Your account is not linked to a company. Please contact support to get access.');
        return;
    }

    preSelectCountry();
    await getBillingAddress(shopId, locationId, customerId);

    document.getElementById('submit-btn').addEventListener('click', () => {
        const hasShipping = document.getElementById('has-shipping')?.checked ?? true;
        if (!validateFields(hasShipping)) {
            alert('Your customer profile is either incomplete or incorrectly filled in.');
            return;
        }
        showTermsPopup(() => performUpdate(shopId, locationId, customerId));
    });
});

const showTermsPopup = (onConfirm) => {
    const overlay = document.createElement('div');
    overlay.className = 'cs-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'cs-terms-title');

    overlay.innerHTML = `
        <div class="cs-popup">
            <h3 class="cs-popup-title" id="cs-terms-title">Terms &amp; Conditions</h3>
            <p class="cs-popup-message">Please review and accept our terms before confirming your details.</p>
            <div class="cs-terms-checkbox-row">
                <input type="checkbox" id="cs-terms-check">
                <label for="cs-terms-check">I accept that my information will be stored according to the
                    <a href="/pages/b2b-terms-and-condition" target="_blank">Terms &amp; Conditions</a>.
                </label>
            </div>
            <div class="cs-popup-actions">
                <button class="cs-popup-btn-secondary" id="cs-terms-cancel">Back</button>
                <button class="cs-popup-btn" id="cs-terms-confirm" disabled>Confirm</button>
            </div>
        </div>
    `;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('cs-popup-overlay--visible'));

    const termsCheckbox = overlay.querySelector('#cs-terms-check');
    const confirmBtn = overlay.querySelector('#cs-terms-confirm');

    termsCheckbox.addEventListener('change', () => {
        confirmBtn.disabled = !termsCheckbox.checked;
    });

    const closePopup = () => {
        overlay.classList.remove('cs-popup-overlay--visible');
        overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
    };

    overlay.querySelector('#cs-terms-cancel').addEventListener('click', closePopup);

    confirmBtn.addEventListener('click', () => {
        closePopup();
        onConfirm();
    });
};

const showFormError = (message) => {
    const form = document.getElementById('customer-settings-form');
    if (!form) return;

    // Disable all interactive elements so the user can't interact with the form
    form.querySelectorAll('input, select, textarea, button').forEach(el => {
        el.disabled = true;
    });

    const overlay = document.createElement('div');
    overlay.className = 'cs-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'cs-popup-title');

    overlay.innerHTML = `
        <div class="cs-popup">
            <div class="cs-popup-icon">&#9432;</div>
            <h3 class="cs-popup-title" id="cs-popup-title">Account not linked</h3>
            <p class="cs-popup-message">${message}</p>
            <button class="cs-popup-btn" id="cs-popup-close">Got it</button>
        </div>
    `;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('cs-popup-overlay--visible'));

    overlay.querySelector('#cs-popup-close').addEventListener('click', () => {
        overlay.classList.remove('cs-popup-overlay--visible');
        overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
    });
};

const getBillingAddress = async (shopId, locationId, customerId) => {
    showLoader();
    try {
        const url = `/secure/company-address/get?shopId=${encodeURIComponent(shopId)}&locationId=${encodeURIComponent(locationId)}&customerId=${encodeURIComponent(customerId)}&type=Billing`;
        const res = await api.fetch(url, { method: 'GET' });
        const json = await res.json();
        if (!json?.success || !json?.data?.address) return;

        const addr = json.data.address;
        document.getElementById('billing_address1').value = addr.address1 || '';
        document.getElementById('billing_address2').value = addr.address2 || '';
        document.getElementById('billing_city').value = addr.city || '';
        document.getElementById('billing_zip').value = addr.zipCode || '';

        const countrySelect = document.getElementById('billing_country');
        if (countrySelect) {
            if (addr.country && countrySelect.querySelector(`option[value="${addr.country}"]`)) {
                countrySelect.value = addr.country;
            } else if (addr.country) {
                for (const opt of countrySelect.options) {
                    if (opt.text === addr.country) {
                        opt.selected = true;
                        break;
                    }
                }
            }
            countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    } catch (error) {
        console.error("Failed to fetch billing address:", error);
    } finally {
        hideLoader();
    }
};


const performUpdate = async (shopId, locationId, customerId) => {
    const submitBtn = document.getElementById('submit-btn');
    const hasShipping = document.getElementById('has-shipping')?.checked ?? true;

    showLoader();
    if (submitBtn) submitBtn.disabled = true;

    try {
        const billing = {
            address1: document.getElementById("billing_address1").value,
            address2: document.getElementById("billing_address2").value,
            city: document.getElementById("billing_city").value,
            zipCode: document.getElementById("billing_zip").value,
            countryCode: document.getElementById("billing_country").value,
        };

        const shipping = hasShipping
            ? {
                address1: document.getElementById("shipping_address1").value,
                address2: document.getElementById("shipping_address2").value,
                city: document.getElementById("shipping_city").value,
                zipCode: document.getElementById("shipping_zip").value,
                countryCode: document.getElementById("shipping_country").value,
            }
            : null;

        const vat = document.getElementById("vat").value.trim();

        const payload = { shopId, locationId, billing, vat, customerId };

        if (shipping) payload.shipping = shipping;

        const updateResponse = await api.fetch("/secure/company-address/update", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const data = await updateResponse.json();
        if (data.statusCode === 200) {
            window.location.assign("/account");
            return;
        } else {
            alert(`Update failed: ${data.message || "Unknown error"}`);
        }
    } catch (error) {
        console.error("Failed to update company location:", error);
        alert("An error occurred while updating addresses. Please try again.");
    } finally {
        if (submitBtn) submitBtn.disabled = false;
        hideLoader();
    }
};
const validateFields = (hasShipping = true) => {
    let valid = true;

    const billingFields = [
        { id: "billing_address1", label: "Address1" },
        { id: "billing_city", label: "City" },
        { id: "billing_zip", label: "Zip code" },
        { id: "billing_country", label: "Country" },
    ];
    billingFields.forEach(({ id, label }) => {
        clearError(id);
        const value = document.getElementById(id).value.trim();
        if (!value) {
            showError(id, `${label} is required`);
            valid = false;
        }
    });

    if (hasShipping) {
        const shippingFields = [
            { id: "shipping_address1", label: "Address1" },
            { id: "shipping_city", label: "City" },
            { id: "shipping_zip", label: "Zip code" },
            { id: "shipping_country", label: "Country" },
        ];
        shippingFields.forEach(({ id, label }) => {
            clearError(id);
            const value = document.getElementById(id).value.trim();
            if (!value) {
                showError(id, `${label} is required`);
                valid = false;
            }
        });
    } else {
        ["shipping_address1", "shipping_city", "shipping_zip", "shipping_country"].forEach(clearError);
    }

    clearError("vat");
    const rawVat = document.getElementById("vat").value;
    const vatClean = rawVat.replace(/[\s-]/g, "").toUpperCase();

    if (!vatClean) {
        showError("vat", "VAT number is required");
        valid = false;
    }

    return valid;
};



//Preselect country in dropdown
const preSelectCountry = () => {
    const select = document.getElementById('shipping_country');
    const defaultCountry = select.getAttribute('data-default');

    if (defaultCountry) {
        for (const option of select.options) {
            if (option.value === defaultCountry || option.text === defaultCountry) {
                option.selected = true;
                break;
            }
        }
    }
}


const showError = (fieldId, message) => {
    const field = document.getElementById(fieldId);
    if (!field) return;

    //Look for existing error span
    let errorSpan = field.parentElement.querySelector(".error-msg");
    if (!errorSpan) {
        errorSpan = document.createElement("span");
        errorSpan.className = "error-msg";
        errorSpan.style.color = "red";
        errorSpan.style.fontSize = "0.9rem";
        errorSpan.style.marginTop = "0.2rem";
        field.parentElement.appendChild(errorSpan);
    }
    errorSpan.textContent = message;

    //highlight the field
    field.classList.add("error");
};

const clearError = (fieldId) => {
    const field = document.getElementById(fieldId);
    if (!field) return;
    field.classList.remove("error");
    const errorSpan = field.parentElement.querySelector(".error-msg");
    if (errorSpan) errorSpan.remove();
};


//Copy shipping to billing
document.addEventListener('DOMContentLoaded', () => {
    const $ = (id) => document.getElementById(id);
    const copyBtn = $('copy-shipping');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', () => {
        const pairs = [
            ['shipping_address1', 'billing_address1'],
            ['shipping_address2', 'billing_address2'],
            ['shipping_city', 'billing_city'],
            ['shipping_zip', 'billing_zip'],
        ];
        pairs.forEach(([src, dst]) => {
            const s = $(src), d = $(dst);
            if (s && d) {
                d.value = s.value || '';
                d.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        const shipCountry = $('shipping_country');
        const billCountry = $('billing_country');
        if (shipCountry && billCountry) {
            billCountry.value = shipCountry.value;
            billCountry.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
});

const showLoader = () => {
    const overlay = document.getElementById('loaderOverlay');
    if (overlay) {
        overlay.style.display = 'block';
        document.body.style.pointerEvents = 'none';
        document.body.style.cursor = 'progress';
        overlay.setAttribute('aria-busy', 'true');
    }
};

const hideLoader = () => {
    const overlay = document.getElementById('loaderOverlay');
    if (overlay) {
        overlay.style.display = 'none';
        document.body.style.pointerEvents = '';
        document.body.style.cursor = '';
        overlay.removeAttribute('aria-busy');
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const hasShipping = document.getElementById('has-shipping');
    const shippingFields = document.getElementById('shipping-fields');

    const toggleShipping = () => {
        if (hasShipping.checked) {
            shippingFields.classList.remove('hidden');
        } else {
            shippingFields.classList.add('hidden');
        }
    };

    toggleShipping();
    hasShipping.addEventListener('change', toggleShipping);
});

document.addEventListener('DOMContentLoaded', () => {
    const hasShipping = document.getElementById('has-shipping');
    const shippingContainer = hasShipping.closest('.cs-address-grid');
    const shippingFields = shippingContainer.querySelectorAll(
        'input:not(#has-shipping), select, textarea, button:not(#has-shipping)'
    );
    const copyButton = document.getElementById('copy-shipping');

    const toggleShippingFields = () => {
        const enabled = hasShipping.checked;

        shippingFields.forEach(el => {
            el.disabled = !enabled;
            if (!enabled) {
                el.classList.add('disabled-field');
            } else {
                el.classList.remove('disabled-field');
            }
        });

        if (copyButton) {
            copyButton.style.display = enabled ? 'inline-block' : 'none';
        }

        shippingContainer.style.opacity = enabled ? '1' : '0.6';
    };

    toggleShippingFields();
    hasShipping.addEventListener('change', toggleShippingFields);
});
